/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  Container,
  Pagination,
  Box,
  SelectChangeEvent,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
} from "@mui/material";
import TableHorizontal from "../../TableHorizontal";
import api from "../../../services/api";
function ListParentChilds() {
  const [pageState, setPageState] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [parentChilds, setParentChilds] = useState([]);
  const columns = [
    "Parent Product",
    "Child Product",
    "Level 1 Option",
    "Level 2 Option",
    "Level 3 Option",
    "Action",
    "Delete",
  ];
  const keys = [
    "parent_product",
    "child_product",
    "level1_option",
    "level2_option",
    "level3_option",
    "action",
    "delete",
  ];
  const fetchData = async (
    page = 1,
    language = 1,
    numberItemsPerPage = 500
  ) => {
    await api
      .get(
        `/product-parent-childs?page=${page}&limit=${numberItemsPerPage}&product_id=${productIDFilter}&search_product_sku=${productSKUFilter}&option_id=${optionIDFilter}&search_option_name=${optionNameFilter}&language_id=${language}`
      )
      .then((res) => {
        setParentChilds(res.data.items);
        setTotalPages(res.data.total_pages);
      });
  };
  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPageState(value);
    fetchData(value);
  };

  const [numberItemsPerPage, setNumberItemsPerPage] = useState("500");
  const handleNumberItemsPerPage = (event: SelectChangeEvent) => {
    setNumberItemsPerPage(event.target.value);
    fetchData(1, Number(language), Number(event.target.value));
  };

  const [language, setLanguage] = useState("1");
  const handleChangeLanguage = (event: SelectChangeEvent) => {
    setLanguage(event.target.value);
    fetchData(1, Number(event.target.value), Number(numberItemsPerPage));
  };

  const [languages, setLanguages] = useState<{ id: number; name: string }[]>(
    []
  );
  const fetchLanguages = async () => {
    const response = await api.get(`languages`);
    setLanguages(response.data.items);
  };

  const [productIDFilter, setProductIDFilter] = useState("");
  const handleChangeProductIDFilter = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setProductIDFilter(e.target.value);
  };

  const [productSKUFilter, setProductSKUFilter] = useState("");
  const handleChangeProductSKUFilter = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setProductSKUFilter(e.target.value);
  };

  const [optionIDFilter, setOptionIDFilter] = useState("");
  const handleChangeOptionIDFilter = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setOptionIDFilter(e.target.value);
  };

  const [optionNameFilter, setOptionNameFilter] = useState("");
  const handleChangeOptionNameFilter = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setOptionNameFilter(e.target.value);
  };

  const handleFilterButtonClick = () => {
    fetchData(1, Number(language));
  };

  useEffect(() => {
    fetchData();
    fetchLanguages();
  }, []);
  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      <Box style={{ display: "flex", flexDirection:"row" }}>
        <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginRight: "8px",
          marginLeft: 1,
        }}
        >
      <InputLabel id="number-items-page-label">
        Number of Items per Page
      </InputLabel>
      <Select
        labelId="number-items-page-select-label"
        id="number-items-page"
        value={numberItemsPerPage}
        label="Number of Items per Page"
        onChange={handleNumberItemsPerPage}
      >
        <MenuItem value={100}>100</MenuItem>
        <MenuItem value={250}>250</MenuItem>
        <MenuItem value={500}>500</MenuItem>
        <MenuItem value={750}>750</MenuItem>
        <MenuItem value={1000}>1000</MenuItem>
      </Select>
      </Box>
      <Box>
      <InputLabel id="language-label">Language</InputLabel>
      <Select
        labelId="language-select-label"
        id="language"
        value={language}
        label="Language"
        onChange={handleChangeLanguage}
      >
        {languages.map((language, index) => (
          <MenuItem value={language.id} key={1}>
            {language.name}
          </MenuItem>
        ))}
      </Select>
      </Box>
      </Box>

      
      <TextField
        //sx={{ mt: 1, minWidth: 3/4 }}
        sx={{ minWidth: 1 / 8, maxWidth: 1 / 6, mx:"8px" }}
        margin="normal"
        //fullWidth
        id={"Product-ID-filter"}
        type="text"
        label="Product ID Filter"
        value={productIDFilter}
        onChange={handleChangeProductIDFilter}
      />
      <TextField
        //sx={{ mt: 1, minWidth: 3/4 }}
        sx={{ minWidth: 1 / 4 }}
        margin="normal"
        //fullWidth
        id={"Product-SKU-filter"}
        type="text"
        label="Product SKU Filter"
        value={productSKUFilter}
        onChange={handleChangeProductSKUFilter}
      />
      <TextField
        //sx={{ mt: 1, minWidth: 3/4 }}
        sx={{ minWidth: 1 / 8, maxWidth: 1 / 6, mx:"8px"}}
        margin="normal"
        //fullWidth
        id={"option-ID-filter"}
        type="text"
        label="Option ID Filter"
        value={optionIDFilter}
        onChange={handleChangeOptionIDFilter}
      />
      <TextField
        //sx={{ mt: 1, minWidth: 3/4 }}
        sx={{ minWidth: 1 / 4 }}
        margin="normal"
        //fullWidth
        id={"option-Name-filter"}
        type="text"
        label="Option Name Filter"
        value={optionNameFilter}
        onChange={handleChangeOptionNameFilter}
      />
      <Button variant="contained" href="" sx={{marginLeft:"16px", mt:"24px"}} onClick={handleFilterButtonClick}>
        Filter
      </Button>
      <TableHorizontal
        screen={"product-parent-childs"}
        columns={columns}
        data={parentChilds}
        objectKey={keys}
      />
      <Box
        display="flex"
        width={"100%"}
        height={80}
        alignItems="center"
        justifyContent="center"
      >
        <Pagination
          count={totalPages}
          page={pageState}
          onChange={handleChange}
        />
      </Box>
    </Container>
  );
}
export default ListParentChilds;
